import { i18n } from '@/plugins/i18n'
import { invertKeyValues } from '@/common/objects'
import { MediaType, MediaStatus, MediaLevel } from '@/constants'
import { mediaStatusOption } from '@/common/data'

export const typeStr = (type) => {
    const typeStr = invertKeyValues(MediaType)[type]

    return typeStr ? i18n.t(`media.types.${typeStr.toLowerCase()}`) : 'undefined'
}

export const mediaStatusColor = (status) => {
    const colors = {
        [MediaStatus.PENDING]: 'warning',
        [MediaStatus.APPROVED]: 'success',
        [MediaStatus.REJECTED]: 'danger',
    }

    return colors[status] ? colors[status] : 'undefined'
}

export const mediaStatusStr = (status) => {
    const statusStr = invertKeyValues(MediaStatus)[status]

    return statusStr ? i18n.t(`media.statuses.${statusStr.toLowerCase()}`) : 'undefined'
}

export const getIcon = (type) => {
    const types = {
        [MediaType.WEBSITE]: 'globe',
        [MediaType.SOCIAL_MEDIA_INSTAGRAM]: ['fab', 'instagram'],
        [MediaType.SOCIAL_MEDIA_TELEGRAM]: ['fab', 'telegram'],
        [MediaType.SOCIAL_MEDIA_FACEBOOK]: ['fab', 'facebook'],
        [MediaType.SOCIAL_MEDIA_YOUTUBE]: ['fab', 'youtube'],
        [MediaType.SOCIAL_MEDIA_TWITTER]: ['fab', 'twitter'],
        [MediaType.SOCIAL_MEDIA_OTHER]: 'hashtag',
    }

    return types[type]
}

export const mediaInputClass = (status) => {
    const obj = mediaStatusOption.find(obj => obj.value === status)

    return obj ? obj.style : ''
}

export const mediaLevelStr = (level) => {
    const levelStr = invertKeyValues(MediaLevel)[level]

    return levelStr ? i18n.t(`media.levels.${levelStr.toLowerCase()}`) : 'undefined'
}